import React from 'react';
import { MutationFunction } from '@apollo/client';
import { useTranslate } from 'nucleus-text';
import { ExternalLoginMutation, ExternalLoginMutationVariables } from '@cvent/universal-login-web-graphql/operations';

import { useTargetProduct } from '@components/providers/ProductProvider';
import { ExternalLoginForm } from '@components/forms/ExternalLoginForm';
import { Title } from '@components/textFields/Title';

type ExternalCventLoginFormProps = {
  testID: string;
  redirectMutation: MutationFunction<ExternalLoginMutation, Omit<ExternalLoginMutationVariables, 'targetProductId'>>;
  productAssertion?: (string) => boolean;
};

export const ExternalCventLoginForm = ({
  testID,
  redirectMutation,
  productAssertion
}: ExternalCventLoginFormProps): JSX.Element => {
  const { translate } = useTranslate();
  const { targetProduct } = useTargetProduct();

  return (
    <ExternalLoginForm
      testID={testID}
      redirectMutation={redirectMutation}
      productAssertion={productAssertion}
      children={{
        title: <Title testID={testID} text={translate('form_title', { targetProduct: targetProduct.label })} />,
        subtitle: null
      }}
    />
  );
};
